import { isPlatform } from '@ionic/core'
import React, { CSSProperties } from 'react'

interface Props {
  web?: boolean
  app?: boolean
  ios?: boolean
  android?: boolean
  desktop?: boolean
  style?: CSSProperties
}

export const Show: React.FC<Props> = ({children, desktop, ios, android, web, app,  ...props}) => {
  if (
    !(web && !isPlatform('capacitor'))
    && !(app && isPlatform('capacitor'))
    && !(desktop && isPlatform('desktop'))
    && !(android && isPlatform('android'))
    && !(ios && isPlatform('ios'))
  ) {
    return null
  }

  return (
    <div {...props}>
      {children}
    </div>
  )
}
